import React from 'react'
import { NodeViewWrapper } from '@tiptap/react'
import { useModal } from '@hooks/contexts/ModalContext/ModalContext'

function Footnote({ node }: any) {
  const footnoteModal = useModal({ modal: 'footnote' }, true)
  return (
    <NodeViewWrapper as='span' id={`footnote-${node.attrs.hrefId}`}>
      <sup>
        <a
          onClick={() => {
            const elments: NodeListOf<HTMLDataListElement> =
              document.querySelectorAll(`#customOrderedList li`)
            if (elments.length) {
              const el = elments[node.attrs.hrefId - 1]
              const content = el ? el.innerText : ''
              footnoteModal.show({
                content,
                refId: node.attrs.hrefId,
                onClose: footnoteModal.hide,
              })
            }
          }}
          style={{ color: '#0c1135', textDecoration: 'unset' }}
        >
          [{node.attrs.hrefId}]
        </a>
      </sup>
    </NodeViewWrapper>
  )
}

export default Footnote
